import { handleAxiosError } from 'core/notifications';
import { useQuery } from '@tanstack/react-query';

import axios from '@/util/axios';
import { useGlobalQueries } from '@/exceed';

import getAxiosConfig from '../helpers/getAxiosConfig';

export default ({ isEnabled = false } = {}) => {
  const { currentProfile } = useGlobalQueries();
  const id = currentProfile.data?.id;
  const queryKey = ['organizationVideoPermissions', id];

  const query = useQuery({
    enabled: isEnabled && currentProfile.isSuccess,
    onError: handleAxiosError,
    queryFn: async () =>
      (await axios(getAxiosConfig('get-organization-video-permissions', { id }))).data,
    queryKey,
  });

  return query;
};
